export default (fixture, apiCall) => {
  if (import.meta.env.VITE_APP_USE_API_FIXTURES) {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({ data: { data: fixture } })
      }, 500)
    })
  }
  return apiCall()
}
